import { ProdlogService } from '@gtpl/shared-services/production';
import { Button, Card, Col, DatePicker, Descriptions, Form, Input, message, Row, Select, Space } from 'antd';
import { DegummingLogReq, DegummingReq } from 'libs/shared-models/production-management/src/lib/production-log/work-order-log-req';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const DegummingForm = () => {
  const [form] = Form.useForm();
  const { Option } = Select;

  const [workOrderNo, setWorkOrderNo] = useState<any[]>([]);
  const [variantData, setVariantData] = useState<any[]>([]);
  const [quality, setQuality] = useState<any[]>([]);
  const [woQty, setWoQty] = useState<any[]>([]);

  const productionLogService = new ProdlogService();
     const plantId=Number(localStorage.getItem("unit_id"));
  const createdUser=JSON.parse(localStorage.getItem('username'));

  useEffect(() => {
    getWorkOrderNoForDegumming();
  }, []);

  const getWorkOrderNoForDegumming = () => {
    productionLogService.getWorkOrderNoForDegumming().then(res => {
      setWorkOrderNo(res.status ? res.data : []);
    });
  };

  const getProductIdByWorkOrderNo = async () => {
    const req = new DegummingReq();
    req.workOrderNo = form.getFieldValue('workOrderNo');

    const res = await productionLogService.getProductIdByWorkOrderNo(req);
    const data = res.status ? res.data : [];

    setVariantData(data);
    if (data.length === 1) {
      form.setFieldsValue({ variantId: data[0].variantId });
      onVariantChange(data[0].variantId);
    }
  };

  const getQualityForDegumming = async () => {
    const req = new DegummingReq();
    req.workOrderNo = form.getFieldValue('workOrderNo');
    req.variantId = form.getFieldValue('variantId');

    const res = await productionLogService.getQualityForDegumming(req);
    const data = res.status ? res.data : [];

    setQuality(data);
    if (data.length === 1) {
      form.setFieldsValue({ quality: data[0].quality });
      onQualityChange(data[0].quality);
    }
  };

  const getWOQtyForDegumming = async () => {
    const req = new DegummingReq();
    req.workOrderNo = form.getFieldValue('workOrderNo');
    req.variantId = form.getFieldValue('variantId');
    req.quality = form.getFieldValue('quality');

    const res = await productionLogService.getWOQtyForDegumming(req);
    setWoQty(res.status ? res.data : []);
  };

const onWorkOrderChange = (value) => {
  form.setFieldsValue({
    variantId: undefined,
    quality: undefined
  });

  setVariantData([]);
  setQuality([]);
  setWoQty([]);

  if (!value) return;

  getProductIdByWorkOrderNo();
};

const onVariantChange = (value) => {
  form.setFieldsValue({
    quality: undefined
  });

  setQuality([]);
  setWoQty([]);

  if (!value) return;

  getQualityForDegumming();
};

const onQualityChange = (value) => {
  setWoQty([]);
  getWOQtyForDegumming();
};

const onFinish = async (values) => {
  try {
    const selectedVariant = variantData.find(
      v => v.variantId === values.variantId
    );
    const qty = Number(values.inputQuantity);
     const remainingQty =
      woQty.length > 0
        ? Number(woQty[0].workOrderQty) - Number(woQty[0].degummedQty)
        : 0;
        if (!values.inputQuantity || isNaN(qty)) {
      message.error("Please enter valid quantity");
      return;
    }
    if (qty <= 0) {
      message.error("Quantity must be greater than 0");
      return;
    }
    if (qty > remainingQty) {
      message.error(`Quantity cannot exceed remaining (${remainingQty})`);
      return;
    }
    const req = new DegummingLogReq(
      values.workOrderNo,
      values.date?.toDate(),        
      plantId,                           
      values.inputQuantity,
      undefined,                    
      values.remarks,
      values.quality,
      values.variantId,
      selectedVariant?.name,
      createdUser
    );
    const res = await productionLogService.createLogForDegumming(req);

    if (res.status) {
      message.success(res.internalMessage||'Degumming created successfully');

      form.resetFields();
      setVariantData([]);
      setQuality([]);
      setWoQty([]);
      getWorkOrderNoForDegumming();
    } else {
      message.error(res.internalMessage||'Failed to create Degumming');
    }

  } catch (error) {
    console.error("🔥 Error while creating degumming log:", error);
  }
};

  const onReset = () => {
    form.resetFields();
    setVariantData([]);
    setQuality([]);
    setWoQty([]);
  };

  return (
    <div>
      <Card
        title={<span style={{ color: 'white' }}>Degumming</span>}
        style={{ textAlign: 'center' }}
        headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
        extra={
          <span>
            <Button>
              <Link to="/degumming">View</Link>
            </Button>
          </span>
        }
      >
        <Descriptions>
          <Descriptions.Item label='Work Order Qty'>
            {woQty.length > 0 ? parseFloat(woQty[0].workOrderQty.toString()).toFixed(2) : 0}
          </Descriptions.Item>
          <Descriptions.Item label='Degummed Input Qty'>
            {woQty.length > 0 ? parseFloat(woQty[0].degummedQty.toString()).toFixed(2) : 0}
          </Descriptions.Item>
          <Descriptions.Item label='Available Qty'>
            {woQty.length > 0 ? parseFloat((woQty[0].workOrderQty - woQty[0].degummedQty).toString()).toFixed(2) : 0}
          </Descriptions.Item>
        </Descriptions>

        <Form form={form} layout='vertical' onFinish={onFinish}>
          
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item label='Date' name='date' rules={[{ required: true }]}>
                <DatePicker style={{ width: '100%' }} />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item label='Work Order No' name='workOrderNo' rules={[{ required: true ,message:'Please select Work Order No'}]}>
                <Select allowClear
  showSearch
  optionFilterProp='children' placeholder='Select Work Order' onChange={onWorkOrderChange} >
                  {workOrderNo.map(e => (
                    <Option key={e.workOrderNo} value={e.workOrderNo}>
                      {e.workOrderNo}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={6}>
  <Form.Item label='Variant' name='variantId' rules={[{ required: true, message: 'Please select Variant' }]}>
    <Select
      allowClear
      showSearch
      optionFilterProp='children'
      placeholder='Select Variant'
      onChange={onVariantChange}
    >
      {variantData.map(e => (
        <Option key={e.variantId} value={e.variantId}>
          {e.name}
        </Option>
      ))}
    </Select>
  </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item label='Quality' name='quality' rules={[
  {
    validator: (_, value) => {
      if (value !== undefined) {
        return Promise.resolve();
      }
      return Promise.reject('Please select Quality');
    }
  }
]}>
                <Select allowClear
  showSearch
  optionFilterProp='children' placeholder='Select Quality' onChange={onQualityChange}>
                  {quality.map(e => (
                    <Option key={e.quality ?? 'null'} value={e.quality}>
  {e.quality ?? 'NULL'}
</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={6}>
              <Form.Item label='Input Quantity' name='inputQuantity' rules={[{ required: true, message: 'Please enter Input Quantity' }]}>
                <Input />
              </Form.Item>
            </Col>
             <Space>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
              <Button danger onClick={onReset}>
                Reset
              </Button>
            </Space>
          </Row>


        </Form>
      </Card>
    </div>
  );
};

export default DegummingForm;